import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "256",
  height: "256",
  fill: "currentColor",
  viewBox: "0 0 200 200"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "m34 80 20-50 16 42zM166 80l-20-50-16 42z" }, null, -1),
    _createElementVNode("circle", {
      cx: "100",
      cy: "110",
      r: "64"
    }, null, -1),
    _createElementVNode("path", {
      fill: "var(--mc-avatar)",
      d: "m64 96 26 10-26 10zM136 96l-26 10 26 10z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "none",
      stroke: "var(--mc-avatar)",
      "stroke-linecap": "round",
      "stroke-width": "6",
      d: "M60 150q40-26 80 0"
    }, null, -1)
  ]))]))
}
export default { render: render }